export default __webpack_public_path__ + "static/media/careembox.1be298d4.jpg";